export const PollSelectors = {
  component: '[data-module="Poll"]',
  showFollowUpQuestion: 'poll-component--show-follow-up-question',
  submitted: 'poll-component--submitted',
  question: {
    title: 'question__title',
    followUp: 'poll-component__question--follow-up',
    answers: {
      button: 'question__answers__button',
      buttonSelected: 'question__answers__button--selected',
    },
  },
  feedbackButton: 'poll-component__feedback-button',
};

export class Poll {
  constructor($node) {
    this.$node = $node;
    this.$answerButtons = $node.querySelectorAll(`.${PollSelectors.question.answers.button}`);
    this.$feedbackButton = $node.querySelector(`.${PollSelectors.feedbackButton}`);
    this.$followUpQuestion = $node.querySelector(`.${PollSelectors.question.followUp}`);

    this.$answerButtons.forEach(($button) => $button.addEventListener('click', this._onSelectAnswer.bind(this, $button)));
    this.$feedbackButton.addEventListener('click', this._submitPoll.bind(this));
  }

  _onSelectAnswer($button) {
    const $answers = $button.parentElement;
    const $question = $answers.parentElement;

    const isFollowUpQuestion = $question.classList.contains(PollSelectors.question.followUp);
    const $selectedAnswer = $answers.querySelector(`.${PollSelectors.question.answers.buttonSelected}`);

    // The main question doesn't allow o select more than one answer,
    // and it's not possible to change the selection once done.
    // The follow-up question allows to select multiple answers and change its selection.
    if ($selectedAnswer && !isFollowUpQuestion) return;

    $button.classList.toggle(PollSelectors.question.answers.buttonSelected);

    if (!isFollowUpQuestion) {
      this._showFollowUpQuestion($button);

      // Disable other question
      const $answerButtons = $answers.querySelectorAll(`.${PollSelectors.question.answers.button}`);
      $answerButtons.forEach(($answerButton) => $answerButton.setAttribute('disabled', 'disabled'));
    } else {
      this._refreshFeedbackButtonState();
    }
  }

  _showFollowUpQuestion($button) {
    const showsFollowUpQuestion = $button.dataset.showsFollowUpQuestion;

    if (showsFollowUpQuestion && showsFollowUpQuestion === '1') {
      this.$node.classList.add(PollSelectors.showFollowUpQuestion);
      return;
    }

    // Submit the poll if there is no follow-up
    // question to show.
    this._submitPoll(600);
  }

  _refreshFeedbackButtonState() {
    const $selectedAnswer = this.$followUpQuestion.querySelector(`.${PollSelectors.question.answers.buttonSelected}`);

    if ($selectedAnswer) return this.$feedbackButton.removeAttribute('disabled');

    return this.$feedbackButton.setAttribute('disabled', 'disabled');
  }

  _submitPoll(delay = 0) {
    setTimeout(() => {
      this.$node.classList.remove(PollSelectors.showFollowUpQuestion);
      this.$node.classList.add(PollSelectors.submitted);
    }, delay);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const $polls = document.querySelectorAll(PollSelectors.component);
  $polls.forEach($poll => new Poll($poll));
});
